// extracted by mini-css-extract-plugin
export default {"config-user":"Configurations_config-user__XgsFd"};